// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"e15a70d9","206":"30b42b0d","395":"ea2387b5","429":"4bd1e48e","551":"175117d6","640":"fccb6eef","851":"cbc160ed","950":"33bb226e"}[chunkId] + ".chunk.js";
};